/* 夏侯惇（字元讓） */
import { defineHero, U, S } from '../define.ts';

export default defineHero({
  id: 'xiahoudun', name: '夏侯惇', sub: '字元讓', faction: 'wei', role: '戰士/刺客', weapon: 'spear',
  look: { statRole: '刺客', /* 2026-10-06：敏將，生命成長照刺客（避免太硬）；定位、技能不變 */ patch: true, eye: 'fierce', beard: 'mustache', fx: '#c9a2ff', c: { plume: '#7a4ab8', metal: '#4a4f60', armor: '#2f4478' } },
  skills: [
    ['黑炎破', 'bolt', '黑色氣勁造成 {65/115/165/215} 傷害，並降低移速 {20/30/40/50}%、攻擊力 {5/10/15/20}%。', { x: { k: 'nuke', dmg: [65, 115, 165, 215], debuff: { ms: [20, 30, 40, 50], atkP: [5, 10, 15, 20], dur: 5 }, fx: 'fire' }, aim: U(480) }],
    ['閃擊', 'blink', '瞬移到敵人身邊並立刻攻擊一次。冷卻 {18/15/12/9} 秒。', { x: { k: 'blinkhit' }, aim: U(480), wardHop: true, cd: [18, 15, 12, 9] }],
    ['邪惡之力', 'passive', '會爆也會閃：閃避 {8/8/15/15}%，普攻 {0/15/15/25}% 機率打出 {1/2/2/2.5} 倍傷害。', { pv: { evade: [8, 8, 15, 15], crit: { chance: [0, 15, 15, 25], mult: [1, 2, 2, 2.5] } } }],
    ['九幽萬魂噬', 'spin', '召喚鬼魂 20 秒，每秒吸取周圍敵人 {32/43/54} 生命；每名被吸的敵人每秒為自己回復 15/20/25 生命。', { x: { k: 'buff', dur: 20, aoe: { dps: [32, 43, 54], r: 260, drain: [15, 20, 25] } }, aim: S(260) }],
  ],
});
